function lockBody(){
    $('body').css({
        'overflow':'hidden'
    });
}
function unlockBody(){
    $('body').css({
        'overflow':'auto'
    });
}
function showVehicleImages(imagePos){
    lockBody();
    $('#vehicle-images-overlay').fadeIn({
        'duration' : 500,
        'start' : function(){
            const image = document.querySelector('#vehicle-images-overlay [data-pos="' + imagePos +'"]');
            if (image) {
                image.scrollIntoView({
                    block: imagePos === '1' ? 'end' : 'start',
                });
            } else {
                $('#vehicle-images-overlay').scrollTop(0);
            }
        }
    });
}
function hideVehicleImages(){
    $('#vehicle-images-overlay').fadeOut(500,function(){
        unlockBody();
    });
}
$(document).ready(function(){
    $('.vehicle-images-show').click(function(event){
        let imagePos = null;
        if (event.currentTarget && event.currentTarget.hasAttribute('data-pos')) {
            imagePos = event.currentTarget.getAttribute('data-pos');
        }
        showVehicleImages(imagePos);
        event.preventDefault();
    });
    $('.vehicle-images-close').click(function(){
        hideVehicleImages();
    });
});
